import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-insurance-company-edit',
    templateUrl: './insurance-company-edit.component.html',
    styleUrls: ['./insurance-company-edit.component.scss'],
    standalone: false
})
export class InsuranceCompanyEditComponent implements OnInit {
  insuranceCompanyId: number;

  constructor(private readonly route: ActivatedRoute) {}

  ngOnInit(): void {
    this.insuranceCompanyId = this.route.snapshot.params['id'];
  }
}
